import axios from 'axios'

export const DocumentsService = {
    loadDocuments: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/documents')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveDocuments: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/documents', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    addPhoto: (filename, url) => {
        return new Promise(
            function (resolve, reject) {
                const payload = {
                    photo: {
                        name: filename,
                        url: url
                    }
                }
                axios.post('/documents/photos', payload)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 201: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    addDocument: (filename, url) => {
        return new Promise(
            function (resolve, reject) {
                const payload = {
                    generalDocs: {
                        name: filename,
                        url: url
                    }
                }
                axios.post('/documents/general-docs', payload)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 201: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    addVideo: (filename, url) => {
        return new Promise(
            function (resolve, reject) {
                const payload = {
                    video: {
                        name: filename,
                        url: url
                    }
                }
                axios.post('/documents/videos', payload)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 201: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/services/documents-service.js